var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// constants
import Routes from '@/constants/Routes';
// components
import RefreshToken from '@/components/RefreshToken';
// stores
import useAccountStore from '@/stores/account';
// helpers
import { parseJwt } from '@/helpers/login';
import { readFromLocalStorage } from '@/helpers/storage';
import { localStorageKeys } from '@/constants/storage';
const PrivateRoutes = ({ isAuthenticated, setAuthenticated }) => {
    const { setUser } = useAccountStore();
    useEffect(() => {
        if (isAuthenticated) {
            setLoggedInUserDetails();
        }
    }, []);
    const setLoggedInUserDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        const accessToken = yield readFromLocalStorage(localStorageKeys.ACCESS_TOKEN);
        if (!accessToken) {
            return;
        }
        const decodedToken = parseJwt(accessToken);
        const userId = decodedToken.sub;
        const userEmail = decodedToken.email;
        setUser({
            sub: userId,
            email: userEmail,
        });
    });
    return (React.createElement(React.Fragment, null, isAuthenticated ? (React.createElement(React.Fragment, null,
        React.createElement(RefreshToken, { setAuthenticated: setAuthenticated }),
        React.createElement(Outlet, null))) : (React.createElement(Navigate, { to: Routes.EXTERNAL_LOGIN, replace: true }))));
};
export default PrivateRoutes;
